import { axiosInstance } from "../../utils";

const actions = {
    FETCH_SELECTS_REQUESTED: 'FETCH_SELECTS_REQUESTED',
    FETCH_SELECTS_SUCCEEDED: 'FETCH_SELECTS_SUCCEEDED',
    FETCH_SELECTS_FAILED: 'FETCH_SELECTS_FAILED',

    FETCH_SELECT_REQUESTED: 'FETCH_SELECT_REQUESTED',
    FETCH_SELECT_SUCCEEDED: 'FETCH_SELECT_SUCCEEDED',
    FETCH_SELECT_FAILED: 'FETCH_SELECT_FAILED',

    DELETE_SELECT_REQUESTED: 'DELETE_SELECT_REQUESTED',
    DELETE_SELECT_SUCCEEDED: 'DELETE_SELECT_SUCCEEDED',
    DELETE_SELECT_FAILED: 'DELETE_SELECT_FAILED',

    removeSelect: (id = undefined) => {
        return {
            type: actions.DELETE_SELECT_REQUESTED,
            payload: id
        }
    },

    deleteSelect: async (id = undefined) => {
        const url = `selects/`+id;

        try {
            const response = await axiosInstance.delete(url);
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    fetchPillverySelects: (params = undefined) => {
        return {
            type: actions.FETCH_SELECTS_REQUESTED,
            payload: params
        }
    },

    fetchPillverySelect: (id = undefined) => {
        return {
            type: actions.FETCH_SELECT_REQUESTED,
            payload: id
        }
    },

    getPillverySelects: async (params = undefined) => {
        const url = `selects`;

        try {
            const selects = await axiosInstance.get(url,{ params });
            return selects.data;
        } catch (error) {
            throw error;
        }
    },

    getPillverySelect: async (selectId = undefined) => {
        const url = `selects/`+selectId;

        try {
            const select = await axiosInstance.get(url);
            return select.data;
        } catch (error) {
            throw error;
        }
    }
};
export default actions;
